import { Box, Grid, Typography } from "@mui/material";
interface Title {
  title: string;
  value: number;
  usdQuote: number;
}

const AccountInfo = (data: Title) => {
  return (
    <Grid item xl={4} sm={12} xs={12}>
      <Box className="card group h-100 shadow-sm rounded">
        <Box className="card-body bg-white ">
          <Box className="d-flex justify-content-between align-items-center mb-5">
            <span className="fs-6 mb-0 fw-bold">{data.title}</span>
          </Box>
          <Box>
            <Typography className="text-cap">UPC Balance</Typography>
            <span className="fw-bold d-inline-flex">
              <img
                className="img-fluid mx-auto"
                width="20"
                data-img-theme="light"
                src="/assets/img/coin_logo.svg"
                alt="UPCX Logo"
              />
              &nbsp;
              {data.value.toLocaleString()} UPC
            </span>
          </Box>
          <Box className="mt-2">
            <Typography className="text-cap">UPC Value</Typography>
            <span className="fw-bold">
              {(data.value * data.usdQuote).toLocaleString()}$
            </span>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default AccountInfo;
